<template>
    <div>
        <Head :title="`Offer #{{ form.offer.id }}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/offers">Offers</Link>
                <span class="text-indigo-400 font-medium">/</span>
                Offer #{{ form.offer.id }}
            </h1>
        </div>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
            <div class="w-full">
                <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Offer</h3>
                <form @submit.prevent="update">
                <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                <span
                    class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    #ID<span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.id }}</span>
                        <label class="ml-5 pb-8 pr-6 w-full lg:w-full" for="remember">
                        <input id="remember" v-model="form.offer.is_for_voucher" class="mr-1" type="checkbox" />
                        <span class="text-sm">is for voucher</span>
                    </label>
                </span>

                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Brand
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            form.brand.name
                        }} - {{ form.offer.brand_id }}</span>
                </span>

                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    MGMT Offer ID / Plan ID
                    <span class="text-gray-900 text-xs font-semibold float-right">Offer ID {{
                            form.offer.mgmt_offer_id
                        }} / Plan ID {{ form.offer.mgmt_plan_id }}</span>
                </span>

                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Price
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.price }}</span>
                </span>

                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Type
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.offer_type }}</span>
                </span>

                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Title
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.title }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Description
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.description }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Runtime
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.runtime }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Payment type
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.payment_type }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Created At
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.created_at }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Updated At
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.updated_at }}</span>
</span>
                    <span
                        class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Deleted At
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.offer.deleted_at }}</span>
                </span>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update offer
                    </loading-button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        offer: Object,
        brand: Object
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                offer: this.offer,
                brand: this.brand
            }),
        }
    },
    methods: {
        update() {
            this.form.post(`/offers/${this.offer.id}`)
        },
    },
}
</script>
